export default __webpack_public_path__ + "static/media/img-07.8969cb71.jpg";